import { memo, useCallback, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { GroupFilter } from 'primary-components';

const GroupFilterLocal = () => {
  const navigate = useNavigate(),
        [searchParams] = useSearchParams(),
        groupName = useMemo(() => searchParams.get("groupName") || undefined, [searchParams]),
        setGroupName = useCallback(val => { // modify carefully to avoid cirular dependencies with other filters
          const currentHash = location.hash
          searchParams.set("groupName", val || "")
          navigate(`${window.location.pathname}?${searchParams.toString()}${currentHash}`);
        }, [navigate, searchParams])

  return (
    <GroupFilter
        groupName={groupName}
        onChange={setGroupName}
    />
  )
}

export default memo(GroupFilterLocal);